import { Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import { WikifolioCard } from "src/components-mui/common/wikifolio-card/wikifolio-card";
import { UNDERLYING_LIST_TREND_WIKIFOLIO_TEST_ID } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.test-ids";
import { IUnderlyingListTrendWikifolio } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.types";

interface IListTrendWikifolioProps {
    wikifolio: IUnderlyingListTrendWikifolio;
}

export const ListTrendWikifolio = ({ wikifolio }: IListTrendWikifolioProps) => {
    const { t } = useTranslation("underlying-overview");

    return (
        <Stack sx={{ gap: 2 }} data-test-id={UNDERLYING_LIST_TREND_WIKIFOLIO_TEST_ID}>
            <Typography component="h4" sx={{ fontSize: "md", fontWeight: "bold" }}>
                {t("trend.heading")}
            </Typography>
            <WikifolioCard wikifolio={wikifolio} />
        </Stack>
    );
};
